import "./Home.module.css";
import CommandCenterHeader from "@/reusable_sections/Header";
import ElevatedIntelligenceForTheBuiltEnvironment from "./sections/ElevatedIntelligenceForTheBuiltEnvironment";
import TheEngineeringHub from "./sections/TheEngineeringHub";
import DigitalDirtLogs from "./sections/DigitalDirtLogs";
import BulkMaterialsDirect from "./sections/BulkMaterialsDirect";
import FieldIntelligence from "./sections/FieldIntelligence";
import TheHeavyIronFleet from "./sections/TheHeavyIronFleet";
import NorthwoodsAuthority from "./sections/NorthwoodsAuthority";
import StartYourProject from "./sections/StartYourProject";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <CommandCenterHeader />
      <ElevatedIntelligenceForTheBuiltEnvironment />
      <TheEngineeringHub />
      <BulkMaterialsDirect />
      <StartYourProject />
      <DigitalDirtLogs />
      <FieldIntelligence />
      <TheHeavyIronFleet />
      <NorthwoodsAuthority />
      <IndustrialFooter />
    </div>;
}